export const LOAD_PRODUCTS = 'checkout/LOAD_PRODUCTS';
export const loadProducts = products => ({
    type: LOAD_PRODUCTS,
    payload: {
        products,
    },
});



// WEBPACK FOOTER //
// ./resources/components/shop/actions/products.js